import React, { ReactElement, Fragment } from 'react';
import useStyles from './styles';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import clsx from 'clsx';
import * as CurrencyUtils from '../../../../utils/currency';
import { Typography } from '@material-ui/core';

interface IProps {
  total: number;
}

export default function VatAmountTotal(props: IProps): ReactElement {
  // console.log('Render VatAmountTotal');
  const styles = useStyles();

  return (
    <Fragment>
      <Typography variant="h5" style={{ marginBottom: '1rem' }}>
        <TranslatedText textMap={Translations.header} />
      </Typography>
      <BlockQuote>
        <div className={styles.container}>
          <TranslatedText textMap={Translations.part1} />

          <span
            className={clsx({
              [styles.label]: true,
              [styles.services]: true,
            })}
          >
            <TranslatedText textMap={Translations.services} />
          </span>

          <TranslatedText textMap={Translations.part2} />

          <span
            className={clsx({
              [styles.label]: true,
              [styles.goods]: true,
            })}
          >
            <TranslatedText textMap={Translations.goods} />
          </span>

          <TranslatedText textMap={Translations.part3} />

          <div
            className={clsx({
              [styles.value]: true,
            })}
          >
            {CurrencyUtils.formatCurrency(props.total)}
          </div>
        </div>
      </BlockQuote>
    </Fragment>
  );
}

interface BlockQuoteProps {
  children: any;
}
function BlockQuote(props: BlockQuoteProps) {
  const styles = useStyles();
  return <div className={styles.quote_block}>{props.children}</div>;
}
